import { render, staticRenderFns } from "./PelletsDealerCarousel.vue?vue&type=template&id=a9ef40f8&scoped=true"
import script from "./PelletsDealerCarousel.vue?vue&type=script&lang=ts"
export * from "./PelletsDealerCarousel.vue?vue&type=script&lang=ts"
import style0 from "./PelletsDealerCarousel.vue?vue&type=style&index=0&id=a9ef40f8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ef40f8",
  null
  
)

export default component.exports